import { registerCustomControlProvider } from '../registry';
import { isSvgLike } from './svgFloating';
import { buildObjectActionsButtons } from './shared';
import { triggerStateChangedRequest } from '~core';

registerCustomControlProvider({
  id: 'group-floating-controls',
  match: (object) => object && object.type === 'group' && !isSvgLike(object),
  create: (manager, group) => {
    const ungroup = () => {
      try {
        const sel = group.toActiveSelection();
        if (sel && window.canvas) {
          window.canvas.setActiveObject(sel);
        }
        if (window.canvas) window.canvas.requestRenderAll();
        try {
          triggerStateChangedRequest();
        } catch (e) {
          console.error('Failed triggering state change after ungroup', e);
        }
      } catch (e) {
        console.error('Ungroup failed', e);
      }
    };

    const options = {
      offsetY: 0,
      offsetX: 0,
      gap: 12,
      // Make placement follow Text logic (prefer vertical top/bottom)
      preferVerticalPlacement: true,
      initialView: 'home',
      views: {
        home: {
          buttons: [
            {
              text: 'Annulla Raggruppamento',
              svg: '/assets/svg/annulla-raggruppamento.svg',
              className: 'btn-customize',
              onClick: () => ungroup(),
            },
            {
              inlineSvg:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M5 14a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm7 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"></path></svg>',
              className: 'btn-customize',
              hideArrow: true,
              children: buildObjectActionsButtons(() => group),
            },
          ],
        },
      },
    };

    return manager.createFloatingControls(group, options);
  },
});
